import { BlocksImageGalleryThumbnail } from 'blocks-nextjs/blocks-web-components/components/image-gallery-thumbnail/image-gallery-thumbnail';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatImageGalleryThumbnail = createComponent({
  react: React,
  tagName: 'cat-image-gallery-thumbnail',
  elementClass: BlocksImageGalleryThumbnail
});
